import { render, staticRenderFns } from "./CustomerCardStandard.vue?vue&type=template&id=26c719fa"
import script from "./CustomerCardStandard.vue?vue&type=script&lang=ts"
export * from "./CustomerCardStandard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCardStandard.vue?vue&type=style&index=0&id=26c719fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports